import _ from 'lodash';
import { ROLES } from 'consts';

const item = role => ({
  id: role,
  text: role.replace(/([A-Z])/g, ' $1').toUpperCase(),
});

const common = [
  item(ROLES.ADMIN),
  item(ROLES.USERS),
  item(ROLES.TEMPLATE),
  item(ROLES.CHANNELADMIN),
  item(ROLES.CHANNELHOST),
  item(ROLES.ANALYTICS),
  item(ROLES.IMAGELIBRARY),
  item(ROLES.AGENCY),
  item(ROLES.INFLUENCER),
  item(ROLES.BCLC),
].sort((a, b) => a.text.localeCompare(b.text));

const superadmin = [
  ...common,
  item(ROLES.CMS),
  item(ROLES.KEYS),
  item(ROLES.TRIVIA),
  item(ROLES.SPORTRADAR),
  item(ROLES.PUSHNOTIFICATION),
  item(ROLES.PASSKITINFO),
].sort((a, b) => a.text.localeCompare(b.text));

export { ROLES } from 'consts';

export const getRoles = auth => {
  const myRoles = _.get(auth, 'currentGroup.myRoles', []);
  return myRoles.includes(ROLES.SUPERADMIN) ? superadmin : common;
};
